/*
 * @Author: pingping.mao
 * @Date: 2022-12-19 13:54:06
 * @LastEditTime: 2022-12-19 13:54:42
 * @LastEditors: pingping.mao
 * @Description: 
 * @FilePath: \common-web\src\api\parameter-config\index.js
 */
import request from "@/utils/request";
const systemUrl = window.env.scimSystem;
const api = {
  getParamsTemplate: (params) => {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template/list`,
      method: "get",
      params,
    });
  },
  getModuleParamsById: (params) => {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template/id`,
      method: "get",
      params,
    });
  },
  getParamsValueByIdAndOrgId: ({templateId, useOrgId, ...args}) => {
    return request({
      url: `${systemUrl}/api/v1/parameter-config/templateId/${templateId}/useOrgId/${useOrgId}`,
      method: "get",
      params: args,
    });
  },
  batchAddOrUpdate(data){
    return request({
      url: `${systemUrl}/api/v1/parameter-config/batch/save-or-update`,
      method: "post",
      data: {
        keys: data,
      },
    });
  }
};
export default api;
